module.exports = __webpack_public_path__ + "img/left.86a6dd47.png";